import React, { useMemo, useReducer } from 'react';
import { Layout } from 'antd';
import { shape, arrayOf } from 'prop-types';
import { Outlet } from 'react-router-dom';
import { LearnProvider, learnReducer, initialState } from '../../appContext/learnContext';
import { StudentSidebar as Sidebar } from '../../components/Sidebar';
import TopBar from '../../components/topBar';
import { footerText } from '../../util/config';

const { Content, Footer } = Layout;

const StudentDashboard = ({ routes }) => {
  const [learnState, learnDispatch] = useReducer(learnReducer, initialState);
  const value = useMemo(() => ({ learnState, learnDispatch }), [learnState]);

  return (
    <LearnProvider value={value}>
      <Layout className="gx-app-layout">
        <Sidebar routes={routes} />
        <Layout>
          <TopBar />
          <Content className="gx-layout-content">
            <div style={{ background: '#FAFBFC' }} className="gx-main-content-wrapper">
              <Outlet />
            </div>
            <Footer>
              <div className="gx-layout-footer-content">{footerText}</div>
            </Footer>
          </Content>
        </Layout>
      </Layout>
    </LearnProvider>
  );
};

StudentDashboard.propTypes = {
  routes: arrayOf(shape({})).isRequired,
};

export default StudentDashboard;
